module.exports = __webpack_public_path__ + "img/dodo.19b10712.gif";